<template>
  <footer class="footer d-flex justify-content-between align-items-center">
    © Copyright 2021-2022 AGCADDY Inventory V1.6
    <a href="javascript:void(0)">Last Update: {{ dateTimeFormat(lastUpdate) }}</a>
  </footer>
</template>

<script>
import DV from '../../static/config.json'
export default {
  data() {
    return {
      lastUpdate: DV.last_update
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/footer_view.vue